import parse from "html-react-parser";

const MessagesComponent = props => {
	const {block} = props;
	const {data} = block;
	return (
		<div className="customContainer" id={block.data.navTitle ? block.data.navTitle.toLowerCase().replace(/ /g, '_') : ''}>
			<div className="row">
				<div className="col s12">
					<h2 className="cbTitle">{ data.title }</h2>	
				</div>
				<div className="col s12 cbDescription">
					{data.description ? parse(data.description) : ''}
				</div>
			</div>
		</div>
	)
};

export default MessagesComponent;
